import { useContext, useEffect } from 'react';
import { MessageContext } from '../contexts/MessageContext';
import { useAnalyticsContext } from '../providers/AnalyticsProvider';

/**
 * Bridge entre MessageContext (loja/dadosEmpresa/pkCliente) e o
 * AnalyticsProvider: dispara carregarConfig sempre que a empresa muda
 * e identifica o cliente quando disponível.
 *
 * Render-less.
 */
const AnalyticsBootstrap: React.FC = () => {
  const { loja, dadosEmpresa, pkCliente } = useContext(MessageContext);
  const { carregarConfig, identificar } = useAnalyticsContext();

  useEffect(() => {
    const empresaId = (dadosEmpresa && (dadosEmpresa.empresaid || dadosEmpresa.pk)) || loja;
    if (empresaId) {
      carregarConfig(String(empresaId));
    }
  }, [loja, dadosEmpresa, carregarConfig]);

  useEffect(() => {
    if (pkCliente) {
      identificar({ externalId: String(pkCliente) });
    } else {
      identificar(undefined);
    }
  }, [pkCliente, identificar]);

  return null;
};

export default AnalyticsBootstrap;
